const breadCrumb = "Lotação de Servidores - Manutenção do Servidor";
const parentRoute = "/cadastro-de-servidor";

const routes = [
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor",
    name: "cadastro-de-habilitacao-do-servidor",
    meta: {
      allowedPermissions: ["habilitacao_list"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilitações do Servidor",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorHome.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor/novo/:servidorId",
    name: "cadastro-de-habilitacao-do-servidor-novo",
    meta: {
      allowedPermissions: ["habilitacao_insert"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilitações do Servidor - Novo",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorCad.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor/editar/:id",
    name: "cadastro-de-habilitacao-do-servidor-editar",
    meta: {
      allowedPermissions: ["habilitacao_update"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilitações do Servidor - Editar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorEdit.vue"
      ),
  },
  {
    path: "/servidor/:servidorId/cadastro-de-habilitacao-do-servidor/visualizar/:id",
    name: "cadastro-de-habilitacao-do-servidor-visualizar",
    meta: {
      allowedPermissions: ["habilitacao_show"],
      breadCrumb: breadCrumb,
      parentRoute: parentRoute,
      pageTitle: "Habilitações do Servidor - Visualizar",
    },
    component: () =>
      import(
        "@/views/ManutencaoServidores/CadastroDeHabilitacaoDoServidor/CadastroDeHabilitacaoDoServidorShow.vue"
      ),
  },
];

export default routes;
